import { IconButton, useTheme } from "@mui/material";
import { EditIcon } from "components";
import { type ReactNode, useState } from "react";

interface StatusFilterEditActionProps {
  /** Rendered only while open, so its queries load (and refetch) on open. */
  renderDrawer: (onClose: () => void) => ReactNode;
}

/** Edit icon that opens a status-filter drawer. */
export const StatusFilterEditAction = ({
  renderDrawer,
}: StatusFilterEditActionProps) => {
  const theme = useTheme();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <IconButton
        aria-label="Select status"
        onClick={() => setIsDrawerOpen(true)}
        sx={{
          flexShrink: 0,
          width: "24px",
          height: "24px",
          p: 0,
        }}
      >
        <EditIcon
          sx={{
            width: "24px",
            height: "24px",
            color: theme.palette.lightBg.high,
          }}
        />
      </IconButton>
      {isDrawerOpen && renderDrawer(() => setIsDrawerOpen(false))}
    </>
  );
};
